/**
 * Created by yezh on 2018/2/24.
 * vuex types
 */

export const LOGIN = 'login'

export const RESTORE = 'restore'

export const LOGOUT = 'logout'

export const TITLE = 'title'



// WEBPACK FOOTER //
// ./src/common/js/types.js